module.exports = __webpack_public_path__ + "img/flip_logo.02f799a2.png";